export const plotStatuses = ['Active', 'Pending', 'Resolved'];

export const plotPriorities = ['High', 'Medium', 'Low'];

export const futureContentTypes = [
  'Encounter',
  'Story Beat',
  'Dungeon',
  'NPC Introduction',
  'Location Reveal',
  'Other',
];
